export const isEntitledToItem = ({ item, entitlements, }) => {
    if (!item)
        return false;
    const set = new Set(Object.keys(entitlements));
    for (const cg of item.cachedGrants || []) {
        if (set.has(cg)) {
            return true;
        }
    }
    return false;
};
export const isEntitledToItemFromClientCache = ({ uuid, client, item, }) => {
    if (!item)
        return false;
    const entitlements = client.getQueryData(['entitlement', uuid || 'public']) || {};
    return isEntitledToItem({
        item,
        entitlements,
    });
};
export const isLocked = ({ isEntitled, item, }) => {
    let isLocked = !isEntitled;
    if (!item)
        return isLocked;
    const isCollection = item.__typename === 'Collection';
    const isNotPurchaseable = item.cachedGrants !== undefined
        ? item.cachedGrants === null || item.cachedGrants.length === 0
        : false;
    if (isCollection && isNotPurchaseable) {
        isLocked = false;
    }
    return isLocked;
};
export const getEntitlementCacheKey = (uuid = 'public', item) => ([
    'entitlement',
    uuid,
    { type: item?.__typename, id: item?.id },
]);
export const updateCachedEntitlement = ({ client, uuid, item, entitlements }) => {
    const key = getEntitlementCacheKey(uuid, item);
    const newIsEntitled = isEntitledToItem({
        item,
        entitlements,
    });
    client.setQueryData(key, newIsEntitled);
};
//# sourceMappingURL=isEntitledToItem.js.map